import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disableGenerateButton() {
    this.element.textContent = "Generating...";
    this.element.style.pointerEvents = "none";
    this.element.classList.add("Button--disabled");
  }
}